const imageModules = require.context("./gallery", false, /\.webp$/);

const images = imageModules
  .keys()
  .sort((a, b) => {
    const numA = Number(a.match(/\d+/)?.[0]);
    const numB = Number(b.match(/\d+/)?.[0]);
    return numA - numB;
  })
  .map((key, index) => ({
    id: index,
    src: imageModules(key),
    alt: `Juliet gallery image ${index + 1}`,
  }));

export default images;